import getCustomOtherStylesStylesheet from './get-custom-global-styles-stylesheet';

const getCustomGlobalStylesRootRule = () => {
  const globalStylesStylesheet = getCustomOtherStylesStylesheet();

  if (!globalStylesStylesheet) {
    return null;
  }

  const rootRule = Array.from(globalStylesStylesheet.cssRules).find(
    (rule) => rule.selectorText === ':root'
  );

  return rootRule;
};

export default getCustomGlobalStylesRootRule;
